export default __webpack_public_path__ + "static/media/hyderabad.8e81e5b9.jpg";